<div class="fixed bottom-20 right-4 z-[200] font-mono text-xs">
  @if (isOpen()) {
  <div
    class="bg-black/80 backdrop-blur-md border border-white/20 rounded-lg shadow-xl p-3 mb-2 w-64 max-h-[60vh] overflow-y-auto">
    <div class="flex items-center justify-between mb-2 pb-2 border-b border-white/10">
      <span class="text-white/70 uppercase tracking-widest text-[10px]">Dev · Views</span>
      @if (isPaused()) {
      <button
        type="button"
        (click)="resume()"
        class="text-amber-400 hover:text-amber-300 text-[10px] uppercase tracking-wider">
        ▶ Resume
      </button>
      }
    </div>

    <div class="flex flex-col gap-1">
      @for (view of views; track view.key) {
      <button
        type="button"
        (click)="jumpTo(view.index)"
        class="flex items-center justify-between gap-2 px-2 py-1.5 rounded text-left transition-colors"
        [class.bg-white/15]="activeIndex() === view.index"
        [class.text-white]="activeIndex() === view.index"
        [class.text-white/70]="activeIndex() !== view.index"
        [class.hover:bg-white/10]="activeIndex() !== view.index">
        <span class="flex items-center gap-2 min-w-0">
          <span class="text-white/40 w-3 text-center">{{ view.index }}</span>
          <span class="truncate">{{ view.label }}</span>
        </span>
        @if (!view.enabled) {
        <span class="text-amber-400 text-[9px] uppercase tracking-wider shrink-0">Off</span>
        }
      </button>
      }
    </div>

    @if (isPaused()) {
    <div class="mt-2 pt-2 border-t border-white/10 text-amber-400/80 text-[10px]">
      Rotation paused — click ▶ Resume to continue cycling
    </div>
    }
  </div>
  }

  <button
    type="button"
    (click)="toggle()"
    class="bg-black/70 hover:bg-black/90 backdrop-blur-md border border-white/20 rounded-full w-10 h-10 flex items-center justify-center text-white shadow-lg transition-colors"
    [title]="isOpen() ? 'Close dev panel' : 'Open dev panel'">
    <span class="text-base leading-none">{{ isOpen() ? '×' : '⚙' }}</span>
  </button>
</div>
